<template>                                    
<div>
  <form novalidate class="md-layout" @submit.prevent="validateUser('bewerbung')"> 
    <md-card class="md-layout-item md-size-100 md-small-size-100" v-bind:class="{ bgdark: isDark }">
      <md-card-header>
        <div class="md-title">Quick-Bewerbung</div>
        <div class="md-subtitle">Bewerben war noch nie so einfach. Formular ausfüllen und los geht's.</div>
      </md-card-header>

    <md-card-content>
      <div class="md-layout md-gutter">
        <div class="md-layout-item md-small-size-100">
          <md-field :class="getValidationClass('firstName')">
            <label for="first-name">Vorname</label>
            <md-input name="first-name" id="first-name" autocomplete="given-name" v-model="form.firstName" :disabled="sending" />
            <span class="md-error" v-if="!$v.form.firstName.required">Das Feld Vorname ist erforderlich</span>
            <span class="md-error" v-else-if="!$v.form.firstName.minlength">Ungültiger Vorname</span>
          </md-field>
        </div>
        <div class="md-layout-item md-small-size-100">
          <md-field :class="getValidationClass('lastName')">
          <label for="last-name">Nachname</label>
          <md-input name="last-name" id="last-name" autocomplete="family-name" v-model="form.lastName" :disabled="sending" />
          <span class="md-error" v-if="!$v.form.lastName.required">Das Feld Nachname ist erforderlich</span>
          <span class="md-error" v-else-if="!$v.form.lastName.minlength">Ungültiger Nachname</span>
        </md-field>
        </div>
      </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item md-small-size-100">
          <md-field :class="getValidationClass('jobTitle')">
            <label for="jobTitle">Unternehmen</label>
            <md-input name="position" id="position" v-model="form.jobTitle" md-dense :disabled="sending">
            </md-input>
            <span class="md-error" v-if="!$v.form.jobTitle.required">Das Feld Position ist erforderlich</span>
          </md-field>
        </div>
        <div class="md-layout-item md-small-size-100">
          <md-field :class="getValidationClass('phoneNumberBusiness')">
            <label for="number">Ihre Telefonnummer</label>
            <md-input type="number" id="number" name="number" autocomplete="number" v-model="form.phoneNumberBusiness" :disabled="sending" />
            <span class="md-error" v-if="!$v.form.phoneNumberBusiness.required">Das Feld Telefonnummer ist erforderlich</span>
            <span class="md-error" v-else-if="!$v.form.phoneNumberBusiness.maxlength">Bitte geben Sie eine gültige Telefonnummer ein</span>
          </md-field>
        </div>
      </div>

        <md-field :class="getValidationClass('emailAddressPrivate')">
        <label for="email">E-Mail</label>
        <md-input type="email" name="email" id="email" autocomplete="email" v-model="form.emailAddressPrivate" :disabled="sending" />
        <span class="md-error" v-if="!$v.form.emailAddressPrivate.required">Das Feld E-Mail ist erforderlich</span>
        <span class="md-error" v-else-if="!$v.form.emailAddressPrivate.email">Bitte geben Sie eine gültige E-Mail Adresse ein</span>
      </md-field>
      <div class="md-layout-item">
      <md-field class="checkbox" :class="getValidationClass('datenschutz')">
       <md-checkbox v-model="form.datenschutz" value="my-checkbox">Hiermit bestätige ich die 
            <router-link v-bind:to="'/datenschutz'" exact>
            <a> Datenschutzbestimmungen</a>
           </router-link>
           <br>
        </md-checkbox>
        <span class="md-error" v-if="!$v.form.datenschutz.required">Bitte bestätigen Sie die Datenschutzbestimmung.</span>
      </md-field>
      <md-field style="margin-top:-10px;" class="checkbox" :class="getValidationClass('approval')">
        <md-checkbox style="line-height:10px;" v-model="form.approval" value="my-checkbox">
          <span style="font-size:10px;line-height:10px;">Datensicherheit ist uns sehr wichtig. Um Ihnen auch in der Zukunft Projekte anbieten zu können, möchten wir Ihre Daten speichern. Über den nachfolgenden Link hinterlegen Sie automatisch Ihre Einverständniserklärung zur Datensicherung. Sie haben jederzeit die Möglichkeit, Informationen über den aktuellen Status Ihrer Daten zu bekommen, sowie Ihre Daten vollständig aus unserem System löschen zu lassen. <br> Ich bin einverstanden, dass meine persönlichen Daten entsprechend der Datenschutzerklärung von der naniungo Deutschland GmbH weiterhin gespeichert und genutzt werden. </span>
        </md-checkbox>
        <span class="md-error" v-if="!$v.form.approval.required">Dieses Feld ist notwendig.</span>
      </md-field>
    </div>
    </md-card-content>

    <md-progress-bar md-mode="indeterminate" v-if="sending" />

    <md-card-actions style="margin-top:40px;">
          <md-button type="submit" class="md-primary" :disabled="sending">senden</md-button>
    </md-card-actions>
  </md-card>
  <!-- <md-snackbar :md-active.sync="userSaved">Liebe/r {{ lastUser }}, wir haben Ihre Bewerbung erhalten</md-snackbar> -->
</form>
</div>
       
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { validationMixin } from 'vuelidate' 

import {
    required,
    minLength,
    maxLength,
    email
  } from 'vuelidate/lib/validators'

export default {
name: 'ApplicationForm',
mixins: [validationMixin],
props: {
  isDark: Boolean
},
 data: () => ({
    active: false,
    value: null,
    firstName: "",
    lastName: "",
    jobTitle: "",
    emailAddressPrivate: "",
    phoneNumberBusiness: "",
    sending: false,
    lastUser: null,
    windowWidth: 0,
    cartItems: ['ids:'],
    formtype: null,
    form: {
      formtype: null,
      firstName: null,
      lastName: null,
      jobTitle: null,
      emailAddressPrivate: null,
      phoneNumberBusiness: null,
      datenschutz: null
    }
}),
 validations: {
      form: {
        firstName: {
          required,
          minLength: minLength(2)
        },
        lastName: {
          required,
          minLength: minLength(2)
        },
        jobTitle: {
          required,
          maxLength: maxLength(40)
        },
        emailAddressPrivate: {
          required,
          email
        },
        phoneNumberBusiness: {
          required,
          minLength: minLength(7),
          maxLength: maxLength(15)
        },
        datenschutz: {
          required
        },
        approval: {
          required
        },
      }
    },
computed: {
  ...mapState({
    candidates: state => state.candidates.candidates,
    cart: state => state.cart.cart
  })
},
methods: {
  ...mapActions('candidates',
      ['addCandidate',
      'getCandidates',
      'deleteCandidate'
    ]),
    getValidationClass (fieldName) {
    const field = this.$v.form[fieldName]

    if (field) {
        return {
        'md-invalid': field.$invalid && field.$dirty
        }
    }},
    clearForm () {
        this.$v.$reset()
        this.form.formtype = null
        this.form.firstName = null
        this.form.lastName = null
        this.form.jobTitle = null
        this.form.emailAddressPrivate = null
        this.form.phoneNumberBusiness = null
        this.form.approval = null
        this.form.dateschutz = null
      },
    saveUser () {
        this.sending = true

        // Instead of this timeout, here you can call your API
        window.setTimeout(() => {
          this.lastUser = `${this.form.firstName} ${this.form.lastName}`
          this.sending = false
          this.$emit('close-dialog')
          this.$emit('user-saved')
          this.clearForm()
        }, 1500)
      },
      validateUser (type) {
        this.$v.$touch()
        if (!this.$v.$invalid) {
          this.saveUser()
          this.addCandidate({ 
            formtype: type,
            firstName: this.form.firstName,
            lastName: this.form.lastName,
            jobTitle: this.form.jobTitle,
            emailAddressPrivate: this.form.emailAddressPrivate,
            phoneNumberBusiness: this.form.phoneNumberBusiness
            })
            // this.emptyCart()
        }
      }
  }
}
</script>

<style lang="scss">
@import '../assets/css/shared.scss';

.md-checkbox .md-checkbox-label {
    height: 20px;
    padding-left: 16px;
    position: relative;
    line-height: 13px !important;
}

.bgdark{
  background-color: $secondary-color !important;
  // .md-field.md-theme-default .md-helper-text, .md-field.md-theme-default .md-count, .md-field.md-theme-default label {
  //   color:$secondary-color !important;
  // }
  // input{
  //   color:white !important;
  // }
}

</style>
